import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeKeywordRule: prophetTypes.DeleteRule = (params) => {
  return axios.delete(`/prophet/keyword-rules`, { params });
};

type UseRemoveKeywordRuleOptions = {
  pageId: string;
  config?: MutationConfig<typeof removeKeywordRule>;
};

export function useRemoveKeywordRule({ config = {}, pageId }: UseRemoveKeywordRuleOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['keyword-rules', pageId]);
    },
    ...config,
    mutationFn: removeKeywordRule,
  });
}
